import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "formContainer",
  class: "container page-container"
}
const _hoisted_2 = {
  key: 0,
  class: "force-page-break"
}
const _hoisted_3 = { class: "font-lead" }
const _hoisted_4 = { class: "form-group-radio" }
const _hoisted_5 = {
  for: 'radio-tilbud',
  id: 'tco_label_radio-tilbud'
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_7 = {
  for: 'radio-produkt',
  id: 'tco_label_radio-produkt'
}
const _hoisted_8 = {
  key: 1,
  class: "overflow-menu overflow-menu--sort overflow-menu--open-right",
  id: "sorting-overflow-menu"
}
const _hoisted_9 = {
  class: "button-overflow-menu",
  "data-js-target": "sorting-overflow-menu-panel",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  "aria-hidden": "true",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#sort-default" })
], -1)
const _hoisted_11 = { class: "selected-value" }
const _hoisted_12 = {
  class: "overflow-menu-inner collapsed",
  id: "sorting-overflow-menu-panel",
  "aria-hidden": "true"
}
const _hoisted_13 = ["aria-selected"]
const _hoisted_14 = { id: "low-score" }
const _hoisted_15 = ["aria-selected"]
const _hoisted_16 = { id: "high-score" }
const _hoisted_17 = ["aria-selected"]
const _hoisted_18 = { id: "low-co2" }
const _hoisted_19 = ["aria-selected"]
const _hoisted_20 = { id: "high-co2" }
const _hoisted_21 = ["aria-selected"]
const _hoisted_22 = { id: "name-asc" }
const _hoisted_23 = ["aria-selected"]
const _hoisted_24 = { id: "name-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TGDetails = _resolveComponent("TGDetails")!
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_OGEvaluateEntry = _resolveComponent("OGEvaluateEntry")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.tgId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TGDetails, {
            formular: this.tgFormular,
            printMode: true,
            blanketId: this.tgId
          }, null, 8, ["formular", "blanketId"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", null, [
      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.titel" })
    ]),
    _createElementVNode("p", _hoisted_3, [
      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.titel.sub" })
    ]),
    _createElementVNode("h5", null, [
      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.tilbud-produkt.overskrift" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        id: 'radio-tilbud',
        type: "radio",
        name: 'radio-tilbud-produkt',
        value: 'offer',
        class: "form-radio radio-large",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.sortOfferProduct) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortRadio($event))),
        "aria-controls": 'radio-tilbud',
        "aria-expanded": "false"
      }, null, 544), [
        [_vModelRadio, this.sortOfferProduct]
      ]),
      _createElementVNode("label", _hoisted_5, [
        _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.tilbud.label" })
      ]),
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        id: 'radio-produkt',
        type: "radio",
        name: 'radio-tilbud-produkt',
        value: 'product',
        class: "form-radio radio-large",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.sortOfferProduct) = $event)),
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortRadio($event))),
        "aria-controls": 'radio-produkt',
        "aria-expanded": "false"
      }, null, 544), [
        [_vModelRadio, this.sortOfferProduct]
      ]),
      _createElementVNode("label", _hoisted_7, [
        _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.produkt.label" })
      ])
    ]),
    (!this.tgId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.label" }),
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.laveste-total" })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", {
              class: "overflow-list",
              role: "menu",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort($event)))
            }, [
              _createElementVNode("li", {
                role: "menuitem",
                "aria-selected": !this.sort || this.sort === 'low-score'
              }, [
                _createElementVNode("button", _hoisted_14, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.laveste-total" })
                ])
              ], 8, _hoisted_13),
              _createElementVNode("li", {
                role: "menuitem",
                "aria-selected": this.sort === 'high-score'
              }, [
                _createElementVNode("button", _hoisted_16, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.højeste-total" })
                ])
              ], 8, _hoisted_15),
              _createElementVNode("li", {
                role: "menuitem",
                "aria-selected": this.sort === 'low-co2'
              }, [
                _createElementVNode("button", _hoisted_18, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.laveste-co2" })
                ])
              ], 8, _hoisted_17),
              _createElementVNode("li", {
                role: "menuitem",
                "aria-selected": this.sort === 'high-co2'
              }, [
                _createElementVNode("button", _hoisted_20, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.højeste-co2" })
                ])
              ], 8, _hoisted_19),
              _createElementVNode("li", {
                role: "menuitem",
                "aria-selected": this.sort === 'name-asc'
              }, [
                _createElementVNode("button", _hoisted_22, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.navn-a-å" })
                ])
              ], 8, _hoisted_21),
              _createElementVNode("li", {
                role: "menuitem",
                "aria-selected": this.sort === 'name-desc'
              }, [
                _createElementVNode("button", _hoisted_24, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.navn-å-a" })
                ])
              ], 8, _hoisted_23)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (this.evaluation?.companies?.length > 0)
      ? (_openBlock(), _createBlock(_component_OGEvaluateEntry, {
          key: 2,
          evaluation: this.evaluation,
          printMode: true,
          printAccordionsClosed: !this.fullPrint,
          printTGId: this.tgId
        }, null, 8, ["evaluation", "printAccordionsClosed", "printTGId"]))
      : _createCommentVNode("", true)
  ]))
}